import DashboardContainer from "../components/NewDashboard/DasboardContainer";

const NewDashboard = () => {
  return <div style={{ background: "#F5F6FA",height:"100%" }}>
    <DashboardContainer />
  </div>;
};

export default NewDashboard;
